import request from '@/utils/request'

export function fetchSupplierList (query) {
  return request({
    url: '/card/api/supplier/index',
    method: 'get',
    params: query
  })
}

export function fetchSupplier (id) {
  return request({
    url: '/card/api/supplier/view',
    method: 'get',
    params: { id }
  })
}

export function createSupplier (data) {
  return request({
    url: '/card/api/supplier/insert',
    method: 'post',
    data
  })
}

export function updateSupplier (data) {
  return request({
    url: '/card/api/supplier/update',
    method: 'post',
    data
  })
}

export function deleteSupplier (id) {
  return request({
    url: '/card/api/supplier/delete',
    method: 'post',
    params: { id }
  })
}

export function fetchTemplateList () {
  return request({
    url: '/card/api/supplier/templates',
    method: 'get'
  })
}

export function fetchTemplate (name) {
  return request({
    url: '/card/api/supplier/template',
    method: 'get',
    params: { name }
  })
}



// WEBPACK FOOTER //
// ./src/card/api/supplier.js